// extracted by mini-css-extract-plugin
module.exports = {"entry":"FaqAccordion_entry__B4AmO","is-collapsed":"FaqAccordion_is-collapsed__3Fu6V","plus-icon":"FaqAccordion_plus-icon__PzdUz","is-expanded":"FaqAccordion_is-expanded__TOUlA"};